import KoalaProductItemWithDesc from "src/components/product-item/KoalaProductItemWithDescription";
import { KoalaProduct } from "src/types/koala/KoalaProduct";

interface KoalaProductsListWithDesc {
  products: KoalaProduct[];
}

const KoalaProductsListWithDesc = ({ products }: KoalaProductsListWithDesc) => {
  return (
    <ul className="flex flex-wrap justify-center gap-y-6">
      {products.map((product) => (
        <li key={product.handle} className="product w-1/2 px-1.5 sm:w-1/3 xl:w-1/4 xl:px-2">
          <KoalaProductItemWithDesc product={product} />
        </li>
      ))}
    </ul>
  );
};

export default KoalaProductsListWithDesc;
